import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

const StudentTable = ({ students, noResults = false }) => {
  const navigate = useNavigate();
  const handleRowClick = id => {
    navigate('/manage/students/' + id);
  };

  if (!students?.length) {
    return (
      <div
        data-cy='student-placeholder'
        className='center pHeader'
        style={{ paddingTop: '50px', minHeight: '300px' }}
      >
        No results found
      </div>
    );
  }

  return (
    <TableContainer id='studentTable'>
      <Table sx={{ minWidth: 650 }} size='small' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>ID</TableCell>
            <TableCell>DOB</TableCell>
            <TableCell align='right'>Level</TableCell>
            <TableCell align='right'>Session</TableCell>
            <TableCell align='right'>Payment</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {students?.map(row => {
            return (
              <TableRow
                onClick={() => {
                  handleRowClick(row.student_id);
                }}
                key={row.student_id}
                sx={{
                  '&:nth-of-type(odd)': {
                    backgroundColor: '#EEEEEE',
                  },
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component='th' scope='row'>
                  {row.student_first_name} {row.student_last_name}
                  {+row.student_baptised === 0 && (
                    <span
                      data-cy='not-baptised-flag'
                      className='ml-2 rounded bg-red-100 px-1 py-0.5 text-xs font-bold text-red-700'
                    >
                      NOT BAPTISED
                    </span>
                  )}
                </TableCell>
                <TableCell>
                  ({row.student_id_type.toUpperCase()}) {row.student_id_number}
                </TableCell>
                <TableCell>
                  {dayjs(row.student_dob).format('DD MMMM YYYY')}
                </TableCell>
                <TableCell align='right'>{row.student_level}</TableCell>
                <TableCell align='right' className='sessionCell'>
                  {row.session}
                </TableCell>
                <TableCell align='right'>
                  {row.payment && 'Paid'}
                  {+row.student_fa === 1 && 'FA'}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StudentTable;
